import React, { useState, useEffect, useContext } from "react"
import styled from "styled-components"
import { FaCheck } from "@react-icons/all-files/fa/FaCheck"
import { FaLock } from "@react-icons/all-files/fa/FaLock"
import * as lookup from "../../../../static/lookup.json"
import { SectionContext } from "../../context/sectionContext"
import { ConditionContext } from "../../context/conditionContext"
import { PageContext } from "../../context/pageContext"
import { JourneyContext } from "../../context/journeyContext"
import { ErrorContext } from "../../context/errorContext"
import {
    generateBI,
    fetchAllJourneyData,
    pdfDownload,
    uploadDocument,
    saveApplication,
    fetchApplicationDetails,
    sendEmailBI,
    s3uploadPdfBI,
    getTOFpaymentReceipt,
    saveTransactionDetails,
    updateUserTrackerDetails,
    getConfigurationsByType,
    salesExpiryStatus
} from "../../../services/apiservice"
import {
    getDateInFormat,
    getStateFromCode,
    getAge,
    findCurrentJourneyCode,
    getValueFromLookup,
    findRiderSA,
    findRiderSAPercent,
    getSourceFromChannel,
    transformReceiptToTransaction,
    isEquitasChannel
} from "../../services/helperFunctions"
import {
    errorToastr,
    successToastr,
    clearToastr,
} from "../../../services/error-handler"
import { wordCapital, lineCapital, applyComma, calculateAge } from '../../../shared/functions'
import useBiContactConsentGate from "../../common/useBiContactConsentGate"
import ContactConsentModal from "../../common/ContactConsentModal"
import SalesExpiredModal from "../../common/SalesExpiredModal"
import {
    IGFP_CONTACT_CONSENT_CONFIG,
    getContactConsentFromJourneyData,
    canSendBiEmailFromJourneyData,
} from "../../services/contactConsentPolicy"
const moment = require('moment')
export default function IgfpBI(props) {
    let [isactive, setIsActive] = useState(true)
    const [sectionState, setSectionState] = useContext(SectionContext)
    const [pageState, setPageState] = useContext(PageContext)
    const [errorState, setErrorState] = useContext(ErrorContext);
    const [journeyState, setJourneyState] = useContext(JourneyContext)
    const [conditionState, setConditionState] = useContext(ConditionContext)

    const [allJourneyData, setAllJourneyData] = useState()
    const [biApiData, setBiApiData] = useState()
    const [payNowOrLater, setPayNowOrLater] = useState("later")
    const [pdfData, setPdfData] = useState("")
    const [agreeToDeclaration, setAgreeToDeclaration] = useState(false)
    const [proceedWithOption, setProceedWithOption] = useState()
    const [location, setLocation] = useState()
    const [isChecked, setIsChecked] = useState(true);
    const [skipPayment, setSkipPayment] = useState(false)
    const [isPayBasba, setIsPayBasba] = useState(false)
    const [gstRate, setGstRate] = useState(null);
    const [showSalesExpiredModal, setShowSalesExpiredModal] = useState(false)

    const contactConsentSnapshot = getContactConsentFromJourneyData(
        journeyState?.journeyData,
        IGFP_CONTACT_CONSENT_CONFIG
    )
    const canSendBiEmail = canSendBiEmailFromJourneyData(
        journeyState?.journeyData,
        IGFP_CONTACT_CONSENT_CONFIG
    )
    const disabledEmailButtonStyle = canSendBiEmail
        ? {}
        : {
            cursor: "not-allowed",
            backgroundColor: "#f4f4f4",
            border: "1px solid #d6d6d6",
            opacity: 0.7,
        }
    const emailAnchorStyle = {
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        color: canSendBiEmail ? undefined : "#7a7a7a",
    }
    const emailButtonTitle = canSendBiEmail
        ? "Send BI on email"
        : contactConsentSnapshot.requiresProposer
            ? "Enter LA and proposer email to enable this button"
            : "Enter email to enable this button"

    const contactConsentGate = useBiContactConsentGate({
        journeyState,
        setJourneyState,
        setConditionState,
        saveApplication,
        config: IGFP_CONTACT_CONSENT_CONFIG,
        buildSavePayload: updatedJourneyData => ({
            applicationData: updatedJourneyData,
            journeyData: {
                _id: journeyState.journeyId,
                lastPage: props.currentPageIndex,
                lastSection: props.currentSectionIndex,
                applicationNo: journeyState.applicationNo,
                illustrationNumber: journeyState.illustrationNumber,
                proposalEntryId: journeyState.proposalEntryId,
                lastPageCode: props.pageId,
                lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
                planOption: journeyState.planOption,
                journeyIdFromStrapi: journeyState.journeyIdFromStrapi,
                channel: journeyState.channel,
            },
        }),
    })

    useEffect(() => {
        if(!journeyState?.channel || !isEquitasChannel(journeyState?.channel)){
            return;
        }
        salesExpiryStatus({
            applicationNumber: journeyState.applicationNo,
        })
            .then(res => {
                setJourneyState(prev => {
                    return {
                        ...prev,
                        salesExpired: res?.status
                    }
                })
            })
            .catch(err => {
                console.log(err, "err")
            })
    }, [journeyState?.channel])
    //container
    const RadioContainer = styled.div`
    width: 100%;
    display: block;
    flex-direction: column;
    margin: 15px 0;
    position: relative;
    box-sizing: border-box;
    font-size: 15px;
    color: #505050;
    float: left;

    & > label {
      margin-left: 8px;
      margin-bottom: 5px;
      color: #505050;
      font-size: 16px;
      background-color: #fff;
      padding: 2px 5px;
      z-index: 999;
      position: relative;
      display: inline-block;
      cursor: default;
      max-width: 100%;
      & > .radio-label {
        text-align: center;
      }
    }

    .card {
      width: 100%;
      border-radius: 1rem;
      padding: 1rem 0;
      border-radius: 15px;
      background-color: #fff;
      position: relative;
      margin: 0px;
      margin-bottom: 0px;
      cursor: pointer;
      height: 9rem;
      margin-top: 0px;
      box-shadow: 0px 0px 20px #ccc;
      transition: all 200ms;

      .amount {
        color: black;
        margin-bottom: 2rem;
        margin-left: 6.5rem;
        border-left: 1px solid #ccc;
        padding-left: 1.5rem;
        height: 3rem;
        font-size: 21px;
      }
      .desc {
        padding: 0.8rem;
        background: #ededed;
        color: black;
        text-align: center;
        padding-right: 34px;
      }
    }

    /*Check tick start  */
    .checked {
      background: #ededed;
      color: #ededed;
      position: absolute;
      left: 2rem;
      top: 1rem;
      height: 2.5rem;
      width: 2.5rem;
      border-radius: 50%;
      padding: 8px;
      & > * {
        font-size: 1.2rem;
      }
    }

    input:checked ~ .card .checked {
      background: #fff;
      color: ${props =>
            props.channel === "A"
                ? "#3e505d"
                : props.channel === "B"
                    ? "#a20a3a"
                    : props.channel === "C"
                        ? "#0ab0ef"
                        : "#eb7f25"};
      color: var(--lumiq-card-bg);
    }
    /*Check tick end */

    .icon-container {
      font-size: 3rem;
      padding: 1rem;
      span {
        border-radius: 50%;
        padding: 1rem;

        background: #3e505d;
        .hero-icon {
          padding-top: 8px;
          color: #fff;
        }
      }
    }

    input:checked ~ .card {
      background-color: ${props =>
            props.channel === "A"
                ? "#3e505d"
                : props.channel === "B"
                    ? "#a20a3a"
                    : props.channel === "C"
                        ? "#0ab0ef"
                        : "#eb7f25"};
      background-color: var(--lumiq-card-bg);
      color: #fff;
      .icon-container-1 {
        span {
          background: #fff;
          .hero-icon {
            color: #3e505d;
          }
        }
      }

      .amount {
        color: white;
        margin-bottom: 2rem;
        margin-left: 6.5rem;
        border-left: 1px solid #ccc;
        padding-left: 1.5rem;
        height: 3rem;
        font-size: 21px;
      }
      .desc {
        padding: 0.8rem;
        background: #ffffff;
        color:black
        text-align: center;
        padding-right: 34px;
      }
    }

    input:not(:checked) ~ .card {
      /* opacity: 0.5; */
      .amount {
        color: #818181;
      }

      .desc {
        color: #3e505d;
      }
    }
    `
    //Helper Functions
   
    async function downloadLinkOfPdf(Base64Pdf) {
        // if(!location){
        //   const result = await s3uploadPdfBI({applicationNumber: journeyState.applicationNo,
        //     Base64Pdf: Base64Pdf,
        //   })
        //   setLocation(result.data.location)
        //   window.open(result.data.location,"_self");
        // }else{
        //   window.open(location,"_self");
        // }
        if (isEquitasChannel(journeyState?.channel)) {
          successToastr("Pdf Download Started...")
        }
        const fileName = `${lookup?.pdfProdutPlanName[journeyState?.journeyIdFromStrapi] ?? ""}_${journeyState.applicationNo}.pdf`
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            var byteCharacters = atob(Base64Pdf)
            var byteNumbers = new Array(byteCharacters.length)
            for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            var byteArray = new Uint8Array(byteNumbers)
            var blob = new Blob([byteArray], { type: "application/pdf" })
            window.navigator.msSaveOrOpenBlob(blob, fileName)
            return
        }
        // For Other Browsers
        let linkSource = "data:application/pdf;filename=" + encodeURIComponent(fileName) + ";base64," + Base64Pdf
        const link = document.createElement("a")
        link.href = linkSource
        link.download = fileName
        document.body.appendChild(link)
        link.click()
        link.remove()

        window.addEventListener(
            "focus",
            function () {
                URL.revokeObjectURL(link.href)
            },
            { once: true }
        )
    }

    const handleOnChange = () => {
        setIsChecked(!isChecked);
    };

    const downloadPdf = async () => {
        let sendEmailPdfData = pdfData
        if (!sendEmailPdfData) {
            if (!biApiData) {
                return
            } else {
                let pdfResult = await pdfDownload({
                    applicationNumber: journeyState.applicationNo,
                    TID: biApiData?.TransactionId || "",
                })
                setPdfData(pdfResult.data.Base64Pdf)
                sendEmailPdfData = pdfResult.data.Base64Pdf
            }
        }
        downloadLinkOfPdf(sendEmailPdfData)
    }

    const printPdf = async () => {
        if (pdfData) {
            printPdf1(pdfData)
        } else {
            let pdfResult = await pdfDownload({
                applicationNumber: journeyState.applicationNo,
                TID: biApiData?.TransactionId || "",
            })
            setPdfData(pdfResult.data.Base64Pdf)
            printPdf1(pdfResult?.data?.Base64Pdf)
        }

        function printPdf1(base64Data) {
          const contentType = "application/pdf";
          const blob = b64toBlob(base64Data, contentType);
          const blobUrl = URL.createObjectURL(blob);
        
          // Open PDF in a new tab
          const newTab = window.open(blobUrl, "_blank");
        
          // Optional: attempt to trigger print (may be blocked by some browsers)
          if (newTab) {
            newTab.onload = () => {
              newTab.print();
            };
          } else {
            alert("Popup blocked. Please allow popups for this site to view and print the PDF.");
          }
        }
        
        function b64toBlob(b64Data, contentType, sliceSize) {
            contentType = contentType || ""
            sliceSize = sliceSize || 512

            var byteCharacters = atob(b64Data)
            var byteArrays = []

            for (
                var offset = 0;
                offset < byteCharacters.length;
                offset += sliceSize
            ) {
                var slice = byteCharacters.slice(offset, offset + sliceSize)

                var byteNumbers = new Array(slice.length)
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i)
                }

                var byteArray = new Uint8Array(byteNumbers)

                byteArrays.push(byteArray)
            }

            var blob = new Blob(byteArrays, { type: contentType })
            return blob
        }

    }
  const sendEmailInBackground = (triggerDataLayer = false) => {
    if (!biApiData) {
      return
    }
    const payload = {
      journeyId: journeyState.journeyId,
      module: "BIEMAIL",
      applicationNumber: journeyState.applicationNo,
      TID: biApiData?.TransactionId || "",
    }
    const maxAttempts = 3
    const retryDelayMs = 3000

    const attemptSend = async (attempt) => {
      try {
        const res = await sendEmailBI(payload)
        console.log(res, "emailRes")
        if (res?.status) {
          successToastr(res.message)
          if (triggerDataLayer) {
            let formControlKey = "email"
            let journeyFormatData = props.applicationDataInJourneyFormat()
          }
          return
        }
        console.error(`sendEmailBI attempt ${attempt} failed:`, res?.message)
        if (attempt >= maxAttempts) {
          errorToastr("BI email could not be sent.")
        }
      } catch (err) {
        console.error(`sendEmailBI attempt ${attempt} failed:`, err)
        if (attempt >= maxAttempts) {
          errorToastr("BI email could not be sent.")
        }
      }
      if (attempt < maxAttempts) {
        await new Promise(resolve => setTimeout(resolve, retryDelayMs))
        await attemptSend(attempt + 1)
      }
    }

    attemptSend(1)
  }


    const sendEmail = (callS3uploadPdf) => {
      if (!biApiData) {
        return
      }
      let payload = {
        journeyId: journeyState.journeyId,
        module: "BIEMAIL",
        applicationNumber: callS3uploadPdf ? journeyState.applicationNo : "",
        TID: biApiData?.TransactionId || "",
      }
      successToastr("Sending email...")
      sendEmailBI(payload).then(res => {
        console.log(res, "emailRes")
        if (res?.status) {
          successToastr(res.message)
        } else {
          errorToastr(res.message || "Failed to send email")
        }
      }).catch(err => {
        console.error("Email send failed:", err)
        errorToastr("Failed to send email. Please try again.")
      })
    }

    //async function to make API call
    const getData = async () => {
        console.log("journeyState", journeyState.journeyId);
        let applicationDetailsPayload = {
            _id: journeyState.journeyId,
        }
        let applicationResult = await fetchApplicationDetails(
            applicationDetailsPayload
        )

        let payload = {
            journeyId: journeyState.journeyId,
            allRowData: true,
            productId: journeyState.productId
        }
        let journeyResult = await fetchAllJourneyData(payload)
        console.log("journeyresult", journeyResult);
        if (journeyResult?.lifeAssuredDetails?.proceedWith) {
            setProceedWithOption(journeyResult?.lifeAssuredDetails?.proceedWith)
        }
        if(journeyResult?.journeyType?.toLowerCase() === "canarapos"){
          setPayNowOrLater("later")
        }
        generateBI(payload).then(async data => {
            console.log(journeyResult, data, "vjhdvhhs")
            setAllJourneyData(journeyResult)
            setJourneyState(prev => {
                return {
                    ...prev,
                    premium: Math.round(JSON.parse(data?.data?.BIJson)?.[JSON.parse(data?.data?.BIJson).length - 1].MODAL_PREM) || 0,
                    journeyData: applicationResult.applicationData,
                    proceedWith : lookup?.proceedWithMapper?.[journeyResult?.lifeAssuredDetails?.proceedWith]
                }
            })
            setBiApiData(data.data);
            pdfDownload({
              applicationNumber: journeyState.applicationNo,
              TID: data.data.TransactionId || "",
            })
            .then(pdfResult => {
              setPdfData(pdfResult.data.Base64Pdf);
            })
            .catch(error => {
              console.error("Error while downloading PDF:", error);
            });
                           
            getTOFpaymentReceipt(journeyState.applicationNo)
            .then(res => {
              const receipts = res.data || [];
              const validReceipts = receipts.filter(receipt => lookup.validReceiptStatus[0].hasOwnProperty(receipt.receiptStatus));
              let sum = 0;
              validReceipts.forEach(receipt => {
                sum += parseInt(receipt.amount);
              });
              if (sum >= (Math.round(JSON.parse(data.data.BIJson)?.[0].MODAL_PREM_TAX))) {
                setSkipPayment(true);
              }
              setJourneyState(prev => ({
                ...prev,
                receipts: validReceipts 
              }));
            })
            .catch(err => console.info(err));
        })
            .catch(err => {
                console.log("error in save application of save application and call BI function")
            })
    }

    const handleEnterPayoutOption = (event, value) => {
        console.log(event.key);
        if (event.key == 'Enter') {
            handlePayOption({ target: { value: value } })
        }

    }

    //Use Effects
    useEffect(() => {
        (async () => {
          console.log("getdata callaed");
          await getData();
          console.log("bidattttaaaa", biApiData);
        })()
    }, [])

    useEffect(() => {
     if (!journeyState?.journeyIdFromStrapi) return;

     getConfigurationsByType({ type: "gst-config" })
       .then(res => {
         const allRates = res?.data?.[0]?.config?.planWiseGSTRates || {};
         const journeyId = journeyState.journeyIdFromStrapi;

         // pick GST rates for this journey
         const journeyRates = allRates[journeyId] || null;
         setGstRate(journeyRates);
       })
       .catch(err => {
         console.error("Failed to fetch GST config", err);
       });
     }, [journeyState?.journeyIdFromStrapi]);
    // useEffect(() => {
    //   storePdfData()
    // }, [biApiData])

    //Page Functions
    const handlePayOption = ({ target }) => {
      if (target.value === "now") {
        setPayNowOrLater("now")
        setIsPayBasba(false)
      } else if (target.value === "later") {
        setPayNowOrLater("later")
        setIsPayBasba(false)
      } else if (target.value === "basba") {
        setIsPayBasba(true)
      }
    }

    const handlePrevious = () => {
      try {
        const payload = {
          journeyId: journeyState.journeyId, 
          buttonClicked:  "Previous", 
        };
        updateUserTrackerDetails(payload)
          .then((response) => {
            if (response?.status) {
              console.log("UserTracker updated successfully:", response.message);
            } else {
              console.error("Error in updating UserTracker:", response?.message);
            }
          })
          .catch((error) => {
            console.error("Error in updateUserTrackerDetails API call:", error);
          })
      } catch (error) {
        console.error("Error in handlePrevious:", error);
      }
        if (proceedWithOption === "manually") {
            props.setCurrentSectionIndex(prev => prev - 1) // this moves to previous section on same page
            setJourneyState(prev => {
                return {
                    ...prev,
                    lastPage: props.currentPageIndex,
                    lastSection: props.currentSectionIndex,
                    premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX),
                    lastPageCode: props.pageId,
                    lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
                    journeyCode: findCurrentJourneyCode(
                        props.pageId,
                        props.sections[props.currentSectionIndex].sectionId
                    ),
                }
            })
        }
    }

    // code of tab enter
    const handleEnterPrevious = (event) => {
        if (event?.key == 'Enter') {
            handlePrevious();
        }
    }
    // code of tab enter
    const handleEnterDownload = (event) => {
        if (event?.key == 'Enter') {
            downloadPdf();
        }
    }
    // code of tab enter
    const handleEnterPrint = (event) => {
        if (event?.key == 'Enter') {
            printPdf();
        }
    }
    // code of tab enter
    const handleEnterEmail = (event) => {
        if (event?.key == 'Enter' && canSendBiEmail) {
            sendEmail(true);
        }
    }
    // code of tab enter
    const handleEnterRecalculate = (event) => {
        if (event?.key == 'Enter') {
            handleReCalculate();
        }
    }

    const handleProceedClick = (ev) => {
        if(journeyState?.salesExpired){
            setShowSalesExpiredModal(true);
            return;
        }
        ev.preventDefault()
        if (!isChecked) return
        contactConsentGate.requestProceed(ev, event => {
            if (skipPayment) {
                handleProceedSkipPayment(event)
            } else {
                handleProceed(event)
            }
        })
    }

    const handleProceed = async ev => {
        ev.preventDefault()
        if (!isChecked) {
            return;
        }
        console.log("tessttttttxxxxxxxxxxx", props);

        // downloadLinkOfPdf(pdfData);
        if (!isEquitasChannel(journeyState?.channel)) {
          sendEmailInBackground();
        }
        const ageBI=calculateAge(allJourneyData?.lifeAssuredDetails?.dob)
            let temp = journeyState.journeySteps
            setJourneyState(prev => {
                return {
                    ...prev,
                    journeySteps: temp,
                    lastPage: props.currentPageIndex,
                    lastSection: props.currentSectionIndex,
                    premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX),
                    lastPageCode: props.pageId,
                    lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
                    paymenPrinttStep: "L",
                    journeyCode: findCurrentJourneyCode(
                        props.pageId,
                        props.sections[props.currentSectionIndex].sectionId
                    ),
                }
            })
        
        console.log("journeystateee222222222222222e", journeyState);
        setSectionState(prev => {
            // making section data empty to load new sectionData
            return {
                ...prev,
                sectionId: null,
                sectionFirstPass: null,
                sectionData: {},
            }
        })
        let sendPayload = {
            applicationData: journeyState.journeyData,
            journeyData: {
                _id: journeyState.journeyId,
                lastPage: props.currentPageIndex,
                lastSection: props.currentSectionIndex,
                applicationNo: journeyState.applicationNo,
                illustrationNumber: journeyState.illustrationNumber,
                proposalEntryId: journeyState.proposalEntryId,
                lastPageCode: props.pageId,
                paymentStep: payNowOrLater === "now" ? "N" : "L",
                lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
                isBasbaAttempted: isPayBasba ? "Y" : "N",
                premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX),
                planOption: journeyState.planOption,
                ageAtBI:ageBI

            },
            // base64Data: pdfData,
            
        }
    saveApplication(sendPayload).then(res => {
            console.log(res, "application response")
            props.setCurrentPageIndex(prev => prev + 1)
            setErrorState({})
            setErrorState({})
            setErrorState({})
            setErrorState({})
            props.setCurrentSectionIndex(0) 
            if (journeyState?.journeyData?.length > 1) {
              const tempPage = journeyState.journeyData[1]
              setPageState(prev => {
                return {
                  ...prev,
                  pageId: tempPage.pageId,
                  pageData: tempPage.pageData,
                }
              })
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionId: null,
                  sectionData: {},
                  sectionFirstPass: null,
                }
              })
            }
            else {
              setSectionState(prev => {
                // making section data empty to load new sectionData
                return {
                  ...prev,
                  sectionId: null,
                  sectionFirstPass: null,
                  sectionData: {},
                }
              })
            }
        }).catch(err => {
            console.log(err, "err in saveApplication benefit-illustration")
        })

        
    }

  const handleProceedSkipPayment = (e) => {
    e.preventDefault();
    const temp = journeyState.journeySteps;
    let makePaymentPageIndex = temp.pages.findIndex(page => page.pageId === "makePayment");
    temp.pages[makePaymentPageIndex].sections = temp.pages[makePaymentPageIndex].sections.filter(section => section.sectionId === "eNach-physicalMandate")
    
    setJourneyState(prev => {
      return {
        ...prev,
        journeySteps: temp
      }
    });
  
    let sendPayload = {
      applicationData: journeyState.journeyData,
      skipPayment:'Y',
      journeyData: {
        _id: journeyState.journeyId,
        lastPage: props.currentPageIndex + 1,
        lastSection: 0,
        applicationNo: journeyState.applicationNo,
        illustrationNumber: journeyState.illustrationNumber,
        proposalEntryId: journeyState.proposalEntryId,
        premium: Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX) || 0,
        lastPageCode: props.pageId,
        paymentStep: "N",
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        planOption: journeyState.planOption,
        canaraPosCaseType: allJourneyData?.journeyType?.toLowerCase() === "canarapos" ? "sendCaseToCustomer" : null
      },
      // base64Data: pdfData,
    }
  
    saveApplication(sendPayload).then(async res => {
      console.log(res, "application response");
      props.setCurrentPageIndex(prev => prev + 1);
      setErrorState({});
      props.setCurrentSectionIndex(0); // this moves to first section of next page
  
      // Save transaction details if skipPayment is true
      if (skipPayment) {
        const validReceipts = journeyState.receipts || [];
        const transactions = validReceipts.map(receipt => transformReceiptToTransaction(receipt, journeyState));
  
        const transactionPayload = {
          journeyId: journeyState.journeyId,
          applicationNumber: journeyState.applicationNo,
          status: 'Success',
          skipPayment: 'Y',
          transactions: transactions
        };
  
        console.info(transactionPayload, "transactionPayload");
        let saveResp = await saveTransactionDetails(transactionPayload);
        console.info(saveResp, "saveTransactionDetails");
      }
      
  
    }).catch(err => {
      console.log(err, "err in saveApplication benefit-illustration");
    });
  }



    const handleReCalculate = () => {

              // user activity
            try {
              const payload = {
                journeyId: journeyState?.journeyId, 
                buttonClicked: "ReCalculate", 
              };
              updateUserTrackerDetails(payload)
                .then((response) => {
                  if (response?.status) {
                    console.log("UserTracker updated successfully:", response.message);
                  } else {
                    console.error("Error in updating UserTracker:", response?.message);
                  }
                })
                .catch((error) => {
                  console.error("Error in updateUserTrackerDetails API call:", error);
                })
            } catch (error) {
              console.error("Error in handleReCalculate:", error);
            }
            props.setCurrentPageIndex(0)
            props.setCurrentSectionIndex(0)
            const tempPage = journeyState.journeyData[0]
            setPageState(prev => {
                return {
                    ...prev,
                    pageId: tempPage.pageId,
                    pageData: tempPage.pageData,
                }
            })
            const tempState = journeyState.journeyData[0].pageData[0]
            setSectionState(prev => {
                return {
                    ...prev,
                    sectionId: tempState.sectionId,
                    sectionData: tempState.sectionData,
                }
            })
    }

    let tableDetailsOne = [
        {
            key: "Name of the policyholder",
            value: (allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? (wordCapital(allJourneyData?.proposerDetails?.firstName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.middleName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.lastName)) : (wordCapital(allJourneyData?.lifeAssuredDetails?.firstName ?? '') + " " + wordCapital(allJourneyData?.lifeAssuredDetails?.middleName ?? '') + " " + wordCapital(allJourneyData?.lifeAssuredDetails?.lastName))) || "",
        },
        {
            key: "Age & Gender",
            value: `${(allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? (getAge(allJourneyData?.proposerDetails?.dob)) : (getAge(allJourneyData?.lifeAssuredDetails?.dob)))} | ${(allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? lineCapital(getValueFromLookup("gender", allJourneyData?.proposerDetails?.gender)) : lineCapital(getValueFromLookup("gender", allJourneyData?.lifeAssuredDetails?.gender)))}`
        },
        {
            key: "Name of Life Assured",
            value: `${wordCapital(allJourneyData?.lifeAssuredDetails?.firstName ?? '') + " " + wordCapital(allJourneyData?.lifeAssuredDetails?.middleName ?? '') + " " + wordCapital(allJourneyData?.lifeAssuredDetails?.lastName)}`,
        },
        {
            key: "Age & Gender",
            value: `${biApiData ? JSON.parse(biApiData.BIJson)?.[0]?.LI_ATTAINED_AGE : ""} | ${lineCapital(getValueFromLookup("gender", allJourneyData?.lifeAssuredDetails?.gender) ?? '') || "NA"}`
        },
        {
            key: "Premium Payment Term",
            value: allJourneyData?.productDetails?.premiumPaymentTerm ? `${lookup.premiumPaymentTermInNumbersIGFP?.[0]?.[allJourneyData?.productDetails?.premiumPaymentTerm]} years` : "NA"
        },
        {
            key: "Consolidation Period",
            value: allJourneyData?.productDetails?.consolidationPeriod ? `${lineCapital(getValueFromLookup("DefaultIGFPDefermentPeriodLookup", allJourneyData?.productDetails?.consolidationPeriod))}` : "NA"
        },
    ]

    let tableDetailsTwo = [
        {
            key: "Policy Term",
            value: allJourneyData?.productDetails?.policyTerm ? `${allJourneyData?.productDetails?.policyTerm} years` : "NA"
        },
        {
          key: "Staff/Corporate Customer",
          value: (allJourneyData?.lifeAssuredDetails?.employmentDetails?.staff == "Y" || allJourneyData?.productDetails?.corporateDiscountInd == "Y") ? "Yes" : "No"
        },
        {
            key: "Income Period",
            value: allJourneyData?.productDetails?.incomePeriod ? `${allJourneyData?.productDetails?.incomePeriod} years` : "NA"
        },
        {
            key: "Income Frequency",
            value: allJourneyData?.productDetails?.incomeFrequency? `${lineCapital(getValueFromLookup("GAINIncomeFrequency", allJourneyData?.productDetails?.incomeFrequency))}` : "NA",
        },
        {
            key: "Amount of Instalment Premium",
            value: allJourneyData?.productDetails?.modalPrem ? `Rs ${applyComma(allJourneyData?.productDetails?.modalPrem)}` : "NA"
        },
        {
            key: "Mode of payment of Premium",
            value: allJourneyData?.productDetails?.premiumFrequency ? `${lineCapital(getValueFromLookup("premiumFrequency_withoutSinglePremium", allJourneyData?.productDetails?.premiumFrequency))}` : "NA"
        }
    ]

    const countryToCheckFrom = allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? allJourneyData?.proposerDetails.communicationDetails.currentAddress.country : allJourneyData?.lifeAssuredDetails.communicationDetails.currentAddress.country

    const planDetailsArray = [
        {
            key: "Name of the Product:",
            value: "Canara HSBC Life Insurance iselect Guaranteed Future Plus Plan"
        },
        {
            key: "Unique Identification No:",
            value: "136N098V06"
        },
        {
            key: "GST Rate (year 1)",
            value: countryToCheckFrom === "IN" ? (gstRate?.gstRateYear1 || "0") + "%": "0%",
        },
        {
            key: "GST Rate (year 2 onwards):",
            value: (gstRate?.gstRateYear2 || "0") + "%"
        },
    ]
  
    const policyDetailsArray = [
      {
          key: "Policy Option",
          value: biApiData && JSON.parse(biApiData?.BIJson)?.[0]?.PLAN_OPTION_DISP ? JSON.parse(biApiData?.BIJson)?.[0]?.PLAN_OPTION_DISP : lookup.planCodesIGFP?.[0]?.[allJourneyData?.productDetails?.planOption]
      },
      {
          key: "Sum Assured on Death (at inception of the policy in Rs.)",
          value: biApiData ? `Rs ${applyComma(allJourneyData?.productDetails?.sumAssured) || ""}` : "NA",  
      },
      {
          key : "Accidental Death Benefit Sum Assured if applicable (at inception of the policy in ₹)",
          value : biApiData && JSON.parse(biApiData?.BIJson)?.[0]?.ADB_DISP ? `Rs ${applyComma(JSON.parse(biApiData?.BIJson)?.[0]?.ADB_DISP)} ` : "NA"
      }
  ] 

    console.info("BI-JSON", biApiData ? JSON.parse(biApiData?.BIJson): "NA")

    const premiumSummaryDetails = [
        {
            key: "Instalment Premium without GST",
            basePlan: biApiData ? `Rs ${applyComma(Math.round(JSON.parse(biApiData?.BIJson)[0]?.MODAL_PREM))}` : "NA",
            rider: "-",
            totalInstallmentPremium: biApiData ? `Rs ${applyComma(Math.round(JSON.parse(biApiData?.BIJson)[0]?.MODAL_PREM))}` : "NA",
        },
        {
            key: "Instalment Premium in First Year with GST",
            basePlan: biApiData ? `Rs ${applyComma(Math.round(JSON.parse(biApiData?.BIJson)[0]?.MODAL_PREM_TAX))}` : "NA",
            rider: "-",
            totalInstallmentPremium: biApiData ? `Rs ${applyComma(Math.round(JSON.parse(biApiData?.BIJson)[0]?.MODAL_PREM_TAX))}` : "NA",
        },
        {
          key: "Instalment Premium 2nd year onwards without GST",
          basePlan: biApiData ? `Rs ${applyComma(Math.round(JSON.parse(biApiData?.BIJson)[1]?.MODAL_PREM))}` : "NA",
          rider: "-",
          totalInstallmentPremium: biApiData ? `Rs ${applyComma(Math.round(JSON.parse(biApiData?.BIJson)[1]?.MODAL_PREM))}` : "NA",
        },
        {
            key: "Instalment Premium 2nd year onwards with GST",
            basePlan: biApiData ? `Rs ${applyComma(Math.round(JSON.parse(biApiData?.BIJson)[1]?.MODAL_PREM_TAX))}` : "NA",
            rider: "-",
            totalInstallmentPremium: biApiData ? `Rs ${applyComma(Math.round(JSON.parse(biApiData?.BIJson)[1]?.MODAL_PREM_TAX))}` : "NA",
        },
    ]

    const dppt = [
        {
            key: "Immediate Income Instalment",
            basePlan: biApiData ? `Rs ${applyComma(Math.round(JSON.parse(biApiData?.BIJson)[0]?.IMM_MODAL_INCOME_INSTAL))}` : "NA",
            rider: "Annual Immediate Income",
            totalInstallmentPremium: biApiData ? `Rs ${applyComma(Math.round(JSON.parse(biApiData?.BIJson)[1]?.IMMEDIATE_INCOME))}` : "NA",
        },
    ]

    const postPPT = [
        {
            key: "Assured Income Instalment",
            basePlan: biApiData ? `Rs ${applyComma(Math.round(JSON.parse(biApiData?.BIJson)[0]?.ASSURED_MODAL_INCOME))}` : "NA",
            rider: "Annual Assured Income",
            totalInstallmentPremium: allJourneyData?.productDetails?.planOption === "GA2TP3" ? biApiData ? `Rs ${applyComma(Math.round(JSON.parse(biApiData?.BIJson)[0]?.ANNUAL_ASSURED_INCOME))}` : "NA" : biApiData ? `Rs ${applyComma(Math.round(JSON.parse(biApiData?.BIJson)[0]?.INCOME_INSTALMENT_A))}` : "NA",
        },
        {
            key: "Loyalty Income Instalment",
            basePlan: biApiData ? `Rs ${applyComma(Math.round(JSON.parse(biApiData?.BIJson)[0]?.MODAL_LA))}` : "NA",
            rider: "Annual Loyalty Income",
            totalInstallmentPremium: biApiData ? `Rs ${applyComma(Math.round(JSON.parse(biApiData?.BIJson)[0]?.LA_ANNUAL))}` : "NA",
        },
        {
            key: "Total Income Instalment",
            basePlan:allJourneyData?.productDetails?.planOption === "GA2TP3" ? biApiData ? `Rs ${applyComma(Math.round(JSON.parse(biApiData?.BIJson)[0]?.TOTAL_INCOME))}` : "NA" : biApiData ? `Rs ${applyComma(Math.round(JSON.parse(biApiData?.BIJson)[1]?.TOTAL_MODAL_INCOME))}` : "NA",
            rider: "Total Annual Income",
            totalInstallmentPremium: allJourneyData?.productDetails?.planOption === "GA2TP3" ? biApiData ? `Rs ${applyComma(Math.round(JSON.parse(biApiData?.BIJson)[0]?.TOT_INCOME_AB))}` : "NA" : biApiData ? `Rs ${applyComma(Math.round(JSON.parse(biApiData?.BIJson)[1]?.ANN_TOT_INSTAL_B))}` : "NA",
        },
    ]

    return (
      <>
        <style>
          {`

          .option-buit-design-new-new-design::after{
            height: 2rem
          }
          .shadow-box-card{
            background-color: #fff;
            box-shadow: 0px 0px 10px #ccc;
            border-radius: 10px;
            padding: 0px 0px;
            float: left;
            width: 100%;
            margin-bottom: 30px;
            height: 172px;
          }
          .option-buit-design-new-structure-sec1 .checkmark, .option-buit-design-new-structure-sec2 .checkmark, .option-buit-design-new-structure-sec3 .checkmark, .option-buit-design-new-structure-sec4 .checkmark {
            background-color: #ededed;
            left: 0px;
            top: 0px;
          }
          radio-line{
            width: 100%;
            height: 100%
          }
          .customradio{
            padding: 22px 0px
          }
          .customradio .checkmark {
            top: 22px !important;
          }
          .by-pay{
            bottom: 8px
          }
          resent-bi-center{
            position: relative;
          }
          .eky-resend {
            margin: auto;
            right: 25px;
            position: relative;
            left: 4px
          }
          .custom-otp{
            margin: auto
          }
          @media screen and (max-width: 767px){
            .Bi-design-structure-table,
            .Bi-design-structure-table .row{
              margin-left: 0 !important;
              margin-right: 0 !important;
            }
            .Bi-design-structure-table .pr,
            .Bi-design-structure-table .pl{
              padding-left: 0 !important;
              padding-right: 0 !important;
            }
            .Bi-design-structure-table .table-responsive{
              width: 100%;
              overflow-x: auto;
              -webkit-overflow-scrolling: touch;
            }
            .Bi-design-structure-table .table td{
              white-space: normal;
            }
            .laesf .table tr {
              border-bottom: 1px solid #e5e5e5;
            }
            .laesf .table td {
              white-space: normal;
              padding: 8px 12px !important;
            }
            .provider .card{
              height: auto !important;
              min-height: 9rem;
            }
            .provider .card .amount{
              margin-left: 4.8rem;
              padding-left: 1rem;
              font-size: 18px;
              margin-bottom: 1rem;
            }
            .provider .card .desc{
              padding-right: 12px;
            }
          }

           .row{
            flex-shrink: 0;
            width: 100%;
            max-width: 100%;
            padding-right: calc(var(--bs-gutter-x) * .5);
            padding-left: calc(var(--bs-gutter-x) * .5);
            margin-top: var(--bs-gutter-y);
          }
      
      `}
        </style>
        {allJourneyData && biApiData && (<div className="container igfp-bi-container">
          <form
            id="declaration-form"
            name="declaration-form"
            action
            method="post"
            autoComplete="off"
            noValidate="novalidate"
          >
            <div className="iselect-padding mt-20">
              <div className="iselect-box-design mb">
                <div className="heading-design">
                  <div className="iselect-padding left-side-head">
                    <h1 className="iselect-heading">Benefit Illustration</h1>
                    <span className="subhead">
                    Canara HSBC Life Insurance iselect Guaranteed Future Plus Plan &nbsp; |
                      &nbsp; UIN: 136N098V06{" "}
                    </span>{" "}
                  </div>
                  <div className="app-quatation mt hidden-desktop-screen">
                    <div className="application-design-number">
                      Application Number: {journeyState.applicationNo}
                    </div>
                  </div>
                </div>
                <div className="bi-summary">
                  <div className="auther-description mt-20">
                  <h3>
                      Dear{" "}
                      {allJourneyData?.journeyType == "CanaraPos" ?
                      <b>
                        { allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? allJourneyData?.proposerDetails?.title === "MR" ? 'Mr. ' :  allJourneyData?.proposerDetails?.title === "MS" ?  'Ms. ' : allJourneyData?.proposerDetails?.title === "MRS" ?  'Mrs. ' : ""
                          : (allJourneyData?.lifeAssuredDetails?.title === "MR" ? 'Mr. ' :  allJourneyData?.lifeAssuredDetails?.title === "MS" ?  'Ms. ' : allJourneyData?.lifeAssuredDetails?.title === "MRS" ?  'Mrs. ': ``)
                        }
                        {allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? (wordCapital(allJourneyData?.proposerDetails?.firstName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.middleName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.lastName)) :wordCapital(allJourneyData?.lifeAssuredDetails?.fullName ?? '')}
                      </b>
                      :
                      <b>
                        { allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? allJourneyData?.proposerDetails?.gender.toUpperCase() == "M" || allJourneyData?.proposerDetails?.gender.toUpperCase() == "T" ? `Mr. ` : `Ms. `
                          : (allJourneyData?.lifeAssuredDetails?.gender.toUpperCase() == "M" || allJourneyData?.lifeAssuredDetails?.gender.toUpperCase() == "T" ? `Mr. ` : `Ms. `)
                        }
                        {allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? (wordCapital(allJourneyData?.proposerDetails?.firstName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.middleName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.lastName)) :wordCapital(allJourneyData?.lifeAssuredDetails?.fullName ?? '')}
                      </b>
                      }
                      {" "}
                </h3>
                    <p className="benefit-title">
                    Thank you for showing interest in our iselect Guaranteed Future Plus Plan. Based on the details provided by you, the illustration customised to your requirements is appended below.
                    </p>
                  </div>
                </div>
                <div className="Bi-design-structure-table mt-50 iselect-mg-bottom">
                  <div className="row">
                    <div class="col-lg-6">
                      <div class="table-responsive table-design laesf">
                        <h2 className="headline-table">Personal Details</h2>
                        <div class="table-bg">
                          <table class="table">
                            <tbody>
                              {tableDetailsOne.map((detail, index) => (
                                <tr
                                  class={
                                    index % 2 == 0
                                      ? "table-color"
                                      : "table-color-grey"
                                  }
                                >
                                  <td>{detail.key}</td>
                                  <td align="right">
                                    <i>{detail.value}</i>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="row ipad-margin-zero px-0">
                        <div class="col-lg-12 pr pl">
                          <div class="table-responsive table-design laesf">
                            <div class="table-bg">
                              <table class="table">
                                <tbody>
                                  {tableDetailsTwo.map((detail, index) => (
                                    <tr
                                      class={
                                        index % 2 == 0
                                          ? "table-color"
                                          : "table-color-grey"
                                      }
                                    >
                                      <td>{detail.key}</td>
                                      <td align="right">
                                        <i>{detail.value}</i>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="clearfix" />
                    <div className="col-lg-12">
                      <div className="table-responsive table-design laesf">
                        <h2 className="headline-table">Plan Details</h2>
                        <div className="table-bg">
                          <table className="table">
                            <tbody>
                              {planDetailsArray.map((detail, index) => (
                                <tr key={index} className={index % 2 === 0 ? "table-color" : "table-color-grey"}>
                                  <td>{detail.key}</td>
                                  <td align="right"><i>{detail.value}</i></td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="clearfix" />
                    <div className="col-lg-12">
                      <div className="table-responsive table-design laesf">
                        <h2 className="headline-table">Policy Details</h2>
                        <div className="table-bg">
                          <table className="table">
                            <tbody>
                              {policyDetailsArray.map((detail, index) => (
                                <tr key={index} className={index % 2 === 0 ? "table-color" : "table-color-grey"}>
                                  <td>{detail.key}</td>
                                  <td align="right"><i>{detail.value}</i></td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="clearfix" />
                    <div className="col-lg-12">
                      <div className="table-responsive table-design">
                        <div className="table-bg" style={{ border: "none" }}>
                          <h2 className="headline-table" style={{ color: '#fff !important', background: 'var(--lumiq-card-bg)', textAlign: 'center' }}>Premium Summary</h2>
                          <table className="table">
                            <tbody>
                              <tr className="headline-table clerte" style={{ color: '#fff !important', borderTop: '1px solid' }}>
                                <td align="center" />
                                <td align="center" style={{ "color": "#fff" }}>Base Plan</td>
                                <td align="center"> Riders</td>
                                <td align="center"> Total Instalment Premium</td>
                              </tr>
                              {premiumSummaryDetails.map(
                                (detail, index) => (
                                  <tr
                                    class={
                                      index % 2 !== 0
                                        ? "table-color"
                                        : "table-color-grey"
                                    }
                                  >
                                    <td>{detail.key}</td>
                                    <td align="center" class="darktxt">
                                      <i>{detail.basePlan}</i>
                                    </td>
                                    <td align="center" class="darktxt">
                                      <i>{detail.rider}</i>
                                    </td>
                                    <td align="center" class="darktxt">
                                      <i>
                                        {detail.totalInstallmentPremium}
                                      </i>
                                    </td>
                                  </tr>
                                )
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="clearfix" />

                <div className="transactionDetailsWrap">
                  <div className="detailContentWrap">
                    <div className="row">
                      <div className="buttonWrap">
                        <div
                          className="button submit-btn"
                          style={{ cursor: "pointer" }}
                          tabIndex="0"
                          onKeyPress={e => handleEnterDownload(e)}
                          onClick={downloadPdf}
                        >
                          <a> Download</a>
                        </div>
                        <div
                          className="button submit-btn"
                          style={{
                            cursor: "pointer",
                            display: isEquitasChannel(journeyState?.channel) ? 'none' : 'inline-block'
                          }}                           
                          tabIndex="0"
                          onKeyPress={e => handleEnterPrint(e)}
                          onClick={printPdf}
                        >
                          <a> Print</a>
                        </div>
                        <div
                          className={canSendBiEmail ? "button submit-btn" : "button manually-submit-btn"}
                          style={{
                            cursor: canSendBiEmail ? "pointer" : "not-allowed",
                            ...disabledEmailButtonStyle,
                          }}
                          tabIndex={canSendBiEmail ? "0" : "-1"}
                          aria-disabled={!canSendBiEmail}
                          title={emailButtonTitle}
                          onKeyPress={e => handleEnterEmail(e)}
                          onClick={() => {
                            if (canSendBiEmail) {
                              sendEmail(true)
                            }
                          }}
                        >
                          <a style={emailAnchorStyle}>
                            {!canSendBiEmail && <FaLock size={12} />}
                            Email
                          </a>
                        </div>
                        <div
                          className="button submit-btn"
                          style={{
                            cursor:
                              proceedWithOption === "manually"
                                ? "pointer"
                                : "default",
                          }}
                          tabIndex="0"
                          disabled={
                            proceedWithOption === "manually" ? false : true
                          }
                          onKeyPress={e => handleEnterRecalculate(e)}
                          onClick={handleReCalculate}
                        >
                          <a>Re-Calculate</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="clearfix" />
                <div className="option-buit-design-new-structure Bi-page-pay-structure mt-30">
                  <div className="col-md-12">
                      {skipPayment && <p style={{
                        textAlign : "center",
                        fontSize : "18px",
                        marginTop : "30px"

                        }}>Premium of Rs {`${biApiData ? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX)) : "NA"}`} is adjusted against transfer of funds from old application</p>}
                  </div>
                </div>
                <div className="clearfix" />
                <div className="iselect-mg-bottom mt-50 medical-btn hidden-desktop-screen">
                  <div className="col-md-12">
                    <div className="but-center text-center">
                    {
                                allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? 
                                (allJourneyData?.proposerDetails?.kycVerified || allJourneyData?.proposerDetails?.ckycVerified || allJourneyData?.proposerDetails?.matchTypeDedupe) &&
                                <div
                                    className="submit-btn cen"
                                    >
                                    {" "}
                                    <a aria-hidden="true" onClick={handlePrevious}>Previous</a>{" "}
                                    </div>
                                :
                                (allJourneyData?.lifeAssuredDetails?.kycVerified || allJourneyData?.lifeAssuredDetails?.ckycVerified || allJourneyData?.lifeAssuredDetails?.matchTypeDedupe) &&
                                <div
                                    className="submit-btn cen"
                                    >
                                    {" "}
                                    <a aria-hidden="true" onClick={handlePrevious}>Previous</a>{" "}
                                    </div>
                                }
                       <input
                        onClick={handleProceedClick}
                        className="previous-btn cen text-uppercase ls2"
                        style={{
                          color: "white",
                          padding: "14px 40px",
                          border: "none",
                        }}
                        type="button"
                        value="PROCEED"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          {!["EQUITAS", "equitas", "36"].includes(journeyState?.channel) && (
          <div class="iselect-mg-bottom">
            <div class="row">
              <div class="col-lg-12">
                <div class="discloser iselect-box-design">
                  <h2>Important Notes : </h2>
                  <ul class="mb-20">
                    {allJourneyData?.productDetails?.planOption === "IG6PT2" || allJourneyData?.productDetails?.planOption === "IG6PT6" ? 
                    <li>
                    Maturity Benefit is the benefit payable on survival of Life Assured till maturity, which is accrued Guaranteed Additions.
                    </li> : allJourneyData?.productDetails?.planOption === "IG6PT3" ? <li>
                    Survival Benefit payable is equal to Guaranteed Income in arrears as per the income frequency post completion of consolidation, till the end of the Policy
                    Term, subject to survival of Life Assured.
                    </li> : allJourneyData?.productDetails?.planOption === "IG6PT1" ?  <li>
                    Maturity Benefit is the benefit payable on survival of Life Assured till maturity, which is Guaranteed Sum Assured on Maturity plus accrued Guaranteed
                    Additions.
                    </li> : allJourneyData?.productDetails?.planOption === "IG6PT5"? <li>
                      Maturity Benefit is the benefit payable on survival of Life Assured till maturity, which is Guaranteed Sum Assured on Maturity plus accrued Guaranteed Additions.
                    </li> 
                    :
                    <li>
                    Maturity Benefit is the benefit payable on survival of Life Assured till maturity, which is Guaranteed Sum Assured on Maturity
                    </li>}
                    {allJourneyData?.productDetails?.planOption === "IG6PT2" ?  
                      <li>Survival Benefit payable is equal to Guaranteed Income as per the income frequency chosen post completion of Premium Payment Term, till the end of
                      the Policy Term, subject to survival of Life Assured.
                      </li> : allJourneyData?.productDetails?.planOption === "IG6PT4" ? <li>
                      Survival Benefit payable is equal to Guaranteed Income in arrears as per the income frequency post consolidation period, till the end of the Policy Term,
                      subject to survival of Life Assured.
                      </li> : ""}

                    {allJourneyData?.productDetails?.planOption === "IG6PT3" || allJourneyData?.productDetails?.planOption === "IG6PT4" ?
                    <li>
                      Death Benefit payable in case of death of the Life Assured - Sum Assured on Death, subject to the minimum of surrender value. No other benefit will be payable and policy will
                      terminate on payment of death benefit. Accidental Death Benefit is not opted.<br />
                       Death Benefit payable in case of death of the Life Assured - Sum Assured on Death, subject to the minimum of surrender value. On death of the Life Assured due to Accident, an
additional amount equal to Accidental Death Benefit Sum Assured is also payable. Accidental Death Benefit Sum Assured will be same as the Sum Assured on Death at policy inception
subject toa maximum of ₹2 crore. No other benefit will be payable and policy will terminate on payment of death benefit.<br />
                     
                      <span style={{ fontWeight: "bold" }}>To be populated if Accidental Death benefit is opted </span> Where, Sum Assured on Death is defined as higher of a) Sum Assured i.e. 11 times the Annualized
                      Premium b) 105% of the Total Premiums Paid
                    </li>
                    :
                    <li>
                      Death Benefit payable in case of death of the Life Assured - Sum Assured on Death plus accrued Guaranteed Additions, subject to the minimum of
                      surrender value. No other benefit will be payable and policy will terminate on payment of death benefit.  Payor Premium Protection Cover,
                      Accidental Death Benefit is not chosen<br />
                      Where Payor Premium Protection Cover has been chosen and Life Assured and Policy holder are the same, on death of the Life Assured, Sum Assured
                      on Death will be paid, all future premiums will be waived off and the Policy shall continue till Maturity with all future benefits accruing as if the Policy
                      was in-force.<br />
                      Where Payor Premium Protection Cover has been chosen and Life Assured and Policy holder are different, on death of the Life Assured, Sum Assured on
                      Death plus accrued Guaranteed Additions will be paid, subject to the minimum of surrender value. No other benefit will be payable and policy will
                      terminate on payment of death benefit. Where Payor Premium Protection Cover has been chosen and Life Assured and Policyholder are different, on
                      death of the Policyholder, all future premiums will be waived off and the Policy shall continue till Maturity with all future benefits accruing as if the
                      Policy was in-force.<br />

                      <span style={{ fontWeight: "bold" }}>To be populated if Payor Premium Protection Cover is opted</span> <br />
                      Death Benefit payable in case of death of the Life Assured - Sum Assured on Death plus accrued Guaranteed Additions, subject to the minimum of
                      surrender value. On death of the Life Assured due to Accident, an additional amount equal to Accidental Death Benefit Sum Assured is also payable.
                      Accidental Death Benefit Sum Assured will be same as the Sum Assured on Death at policy inception subject to a maximum of ₹2 crore. No other benefit
                      will be payable and policy will terminate on payment of death benefit.<br />
                      <span style={{ fontWeight: "bold" }} > To be populated if Accidental Death benefit is opted </span> Where, Sum Assured on Death is defined as higher of a) Sum Assured i.e. 11 times the Annualized
                      Premium b) 105% of the Total Premiums Paid


                    </li>}
                    
                    {allJourneyData?.productDetails?.planOption === "IG6PT3" ?  <li>
                      Consolidation Period is the period, in years, commencing from the date of commencement of the Policy to the date of commencement of income period
                      </li> : allJourneyData?.productDetails?.planOption === "IG6PT4" ? <li>Consolidation Period is the period, in years, commencing from the date of commencement of the Policy to the date of commencement of
                      income period.</li> :""}
                    <li>
                    The installment premium is for healty individual with standard premium rates inclusive of loadings for modal premium, if any. Your application will be
                    assessed as per Board approved underwriting Policy of the Company. Basis underwriting, it may result in extra premium to be paid, which shall be borne
                    by you. Installment premium shall be updated accordingly in case of any additional loadings basis underwriting.

                    </li>
                    <li>
                    A Policy shall acquire lapse status if the Policyholder fails to pay due premium within the Grace Period in the first Policy year. In such case your Policy
                    will lapse at the expiry of the Grace Period and the insurance cover will cease immediately. No benefit shall be payable upon death or upon your request
                    for termination of the Policy or on the expiry of the revival period.

                    </li>
                    <li>
                    Total Premiums Paid means total of all the premiums paid under the base product, excluding any extra premiums and taxes, if collected explicitly.

                    </li>
                   
                  </ul>
                  <h2>Other points to note:</h2>
                  <ul>
                    <li>
                    This is a traditional plan intended for short term/ long term savings and benefits. It is strongly advised that the Policy should be continued throughout the
                    defined Policy term to realise the full benefits. If premiums are discontinued after payment of at least first full Policy years’ premium then the Policy will
                    acquire a Paid-up value.You will receive the Paid-up benefits as applicable under Policy , provided you have not surrendered or revived the Policy.

                    </li>
                    <li>
                    Your Policy will acquire a Guaranteed Surrender Value (GSV) after payment of at least first 2 consecutive Policy years’ premiums. However, the Company may
                    offer a Special Surrender Value (SSV) after completion of first policy year provided one full year premium has been received,and higher of (GSV or SSV) subject
                    to a minimum of zero will be paid on surrender.The Illustration shows both the GSV as well as the current SSV payable on surrender of the Policy. SSV scales
                    may be revised in the future as per the annual review of the prevailing yield on 10 Year G Sec and the underlying experience.


                    </li>
                    <li>
                    Premiums payable and benefits receivable under this plan may be eligible for tax benefits as per the prevailing tax laws subject to amendments from time
                    to time.

                    </li>
                    <li>
                    For more details on product features and terms and conditions, please read sales brochure or sample policy contract carefully before concluding a sale.

                    </li>
                    <li>
                    Insurance is the subject matter of solicitation.

                    </li>
               
                  </ul>
                </div>
              </div>
            </div>
          </div>
          )}
          {/* <!--mobile view button--> */}
          <div className="mobile-view-btn-Q1 pd-mobile-space-structure button1">
            <div className="iselect-mg-bottom">
              <div className="col-md-12">
                <div className="but-center text-center">
                {
                                allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? 
                                (allJourneyData?.proposerDetails?.kycVerified || allJourneyData?.proposerDetails?.ckycVerified || allJourneyData?.proposerDetails?.matchTypeDedupe) &&
                                <div
                                    className="submit-btn cen"
                                    style={{ marginRight: "5px" }}
                                    >
                                    {" "}
                                    <a aria-hidden="true" onClick={handlePrevious}>Previous</a>{" "}
                                    </div>
                                :
                                (allJourneyData?.lifeAssuredDetails?.kycVerified || allJourneyData?.lifeAssuredDetails?.ckycVerified || allJourneyData?.lifeAssuredDetails?.matchTypeDedupe) &&
                                <div
                                    className="submit-btn cen"
                                    style={{ marginRight: "5px" }}
                                    >
                                    {" "}
                                    <a aria-hidden="true" onClick={handlePrevious}>Previous</a>{" "}
                                    </div>
                                }
                  <div className="previous-btn cen">
                    <a>
                      {" "}
                      <button
                        value="button1"
                        style={{
                          backgroundColor: "transparent",
                          border: "none",
                          color: "#fff",
                        }}
                        onClick={handleProceedClick}
                      >
                        Proceed
                      </button>{" "}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <!--mobile view button-->  */}
          <div className="clearfix"></div>
        </div>)}

      <ContactConsentModal
        show={contactConsentGate.showModal}
        initialValues={contactConsentGate.initialValues}
        onClose={contactConsentGate.handleModalClose}
        onProceed={contactConsentGate.handleModalProceed}
        channel={props.channel}
        lookup={journeyState.lookup}
      />
      {showSalesExpiredModal && <SalesExpiredModal />}
      </>
    )
  }